
import Head from "next/head";
import { useRouter } from 'next/compat/router'
import styled from "styled-components";
import LayoutBlog from "../containers/LayoutBlog";
import { Box } from "../components/Basics";
import SVGIcons, { iconTypes } from '../components/SVGIcons';

const Container = styled.div`
    display: flex;
    margin: 0 200px;
    padding: 0 200px;
    
    @media only screen and (max-width: 1600px){
        padding: 0 50px;
    }
    
    @media only screen and (max-width: 1200px){
        margin: 0 50px;
    }
    
    @media only screen and (max-width: 600px) {
        margin: 0;
    }
`;

const StyledBoxMessage = styled(Box)`
  width: 100%;
  background: #ffffff;
  padding: 80px;
  margin-bottom: 20px;

  @media only screen and (max-width: 1300px) {
    padding: 20px 50px;
    margin: 100px 50px;
  }
  @media only screen and (max-width: 800px) {
    margin: 20px;
    padding: 20px;
  }
`;

const StyledAlert = styled.div`
  display: flex;
  min-height: 15vh; 
  align-items: center;
  text-align: left;
  font-weight: bold;
  width: 100%;
  gap: 10px;

  &:first-child {
    margin: 20px 0;
    font-size: 1.8rem;
  }

  &:last-child {
    transition: all 0.2s;
    cursor: pointer;
    font-size: 1.5em;

    &:hover {
      transform: scale(1.05);
    }
  }

  span {
    margin-left: 10px;
  }
`;

const StyledMessage = styled.div`
  font-size: 1.5rem;
  text-align: start;
  line-height: 3rem;

  dl {
    dt {
      margin-bottom: 10px;
    }

    dd {
      margin-left: 30px;
    }
  }

  @media only screen and (max-width: 500px) {
    margin: 10px;
  }
`;

const StyledTeam = styled.p`
  text-align: end;
  line-height: 4rem;
  font-size: 1.8rem;
`;

const Custom404 = () => {
  const router = useRouter();

  const handleBackClick = () => {
    router.back();
  };

  return (
    <LayoutBlog ssrLang="ssrLang">
      <Head>
        <title>Página não encontrada</title>
      </Head>
      <main>
          <Container>
             <StyledBoxMessage>
                <StyledAlert><SVGIcons type={iconTypes.ALERT_ICON} width={35} height={35}/> Página não encontrada</StyledAlert>
                <StyledMessage>
                  <dl>
                    <dt>
                      Desculpe, mas a página que você tentou acessar não existe
                      ou não pode ser exibida. Isso pode ter ocorrido por algum
                      dos motivos abaixo:
                    </dt>
                    <dd>
                      - O endereço digitado pode estar errado ou desatualizado;
                    </dd>
                    <dd>
                      - O seu acesso ao recurso solicitado pode estar bloqueado;
                    </dd>
                  </dl>
                  Certos de sua compreensão,
                </StyledMessage>
                <StyledTeam>Equipe webproject.</StyledTeam>
                <StyledAlert onClick={handleBackClick}>
                  <SVGIcons
                    type={iconTypes.ARROW_BACK}
                    width={30}
                    height={30}
                  />
                  {" "}
                  Voltar a página anterior!
                </StyledAlert>
              </StyledBoxMessage>
          </Container>
      </main>
    </LayoutBlog>
  );
};

export default Custom404;